import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { presetRange, rowsToCsv, saveBlob } from "../finance/invoice-analytics/iaUtils";

export const LEAD_PRESETS = [["all", "All time"], ["today", "Today"], ["this_week", "This week"],
  ["this_month", "This month"], ["last_month", "Last month"], ["custom", "Custom"]];

export const rangeFor = (preset, custom) =>
  preset === "all" ? ["", ""] : preset === "custom" ? [custom.from, custom.to] : presetRange(preset);

const localDay = (iso) => {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
export const inRange = (iso, [from, to]) => {
  if (!from && !to) return true;
  if (!iso) return false;
  const d = localDay(iso);
  return (!from || d >= from) && (!to || d <= to);
};

export const delayHrs = (l, now = Date.now()) => {
  const a = l.updated_at || l.created_at;
  return a ? Math.max(0, (now - new Date(a).getTime()) / 3600000) : 0;
};
export const delayLevel = (h) => (h >= 34 ? "stale" : h >= 24 ? "warn" : "ok");
export const fmtDelay = (h) => (h < 1 ? "<1h" : h < 48 ? `${Math.floor(h)}h` : `${Math.floor(h / 24)}d ${Math.floor(h % 24)}h`);
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", {
  day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

const LEAD_HEAD = ["Name", "Phone", "Email", "Source", "Location", "Stage", "Captured", "Last updated", "Delay", "Notes"];
const leadRow = (l, now) => [l.name, l.phone, l.email, l.source || "manual", l.location, l.status,
  fmtDate(l.created_at), fmtDate(l.updated_at || l.created_at), fmtDelay(delayHrs(l, now)), l.notes];

const fileTag = ([from, to], stage) => `${stage || "all"}_${from || "all-time"}${to ? `_to_${to}` : ""}`;

export function exportLeadsCsv(leads, range, stage) {
  const now = Date.now();
  saveBlob(rowsToCsv(LEAD_HEAD, leads.map(l => leadRow(l, now))), `leads_${fileTag(range, stage)}.csv`);
}

export function exportLeadsPdf(leads, range, stage, stages) {
  const now = Date.now();
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const w = doc.internal.pageSize.getWidth();
  doc.setFillColor(210, 50, 71); doc.rect(0, 0, w, 22, "F");
  doc.setTextColor(255); doc.setFontSize(15); doc.text("Rescigo · Leads Pipeline", 12, 10);
  doc.setFontSize(9);
  doc.text(`Stage: ${stage || "All"}  ·  Captured: ${range[0] || "all time"}${range[1] ? ` to ${range[1]}` : ""}`, 12, 17);
  doc.text(`Generated ${new Date().toLocaleString("en-IN")}`, w - 12, 10, { align: "right" });
  doc.text(`${leads.length} leads`, w - 12, 17, { align: "right" });
  doc.setTextColor(30);
  const counts = stages.map(s => [s, leads.filter(l => l.status === s).length]);
  const stale = leads.filter(l => delayLevel(delayHrs(l, now)) === "stale").length;
  autoTable(doc, {
    startY: 27, head: [["Total", ...counts.map(([s]) => s), "Delayed >34h"]],
    body: [[leads.length, ...counts.map(([, n]) => n), stale]],
    styles: { fontSize: 9, halign: "center" }, headStyles: { fillColor: [26, 26, 26] }, tableWidth: "auto",
  });
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 6, head: [LEAD_HEAD],
    body: leads.map(l => leadRow(l, now).map(v => String(v ?? ""))),
    styles: { fontSize: 7, cellPadding: 1.5, overflow: "linebreak" },
    headStyles: { fillColor: [26, 26, 26] }, columnStyles: { 9: { cellWidth: 55 } },
    didParseCell: (d) => {
      if (d.section !== "body" || d.column.index !== 8) return;
      const lvl = delayLevel(delayHrs(leads[d.row.index], now));
      if (lvl !== "ok") d.cell.styles.textColor = lvl === "stale" ? [122, 46, 24] : [122, 90, 17];
    },
  });
  doc.save(`leads_${fileTag(range, stage)}.pdf`);
}

export function exportContactsCsv(rows, range) {
  const now = Date.now();
  const head = ["Name", "Phone", "Email", "Visitor type", "Organisation", "Location", "Message", "Status",
    "Submitted", "Last updated", "Delay"];
  saveBlob(rowsToCsv(head, rows.map(r => [r.name, r.phone, r.email, r.role, r.organisation || r.organization,
    r.location, r.message || r.notes, r.status, fmtDate(r.created_at), fmtDate(r.updated_at || r.created_at),
    fmtDelay(delayHrs(r, now))])), `contact-submissions_${fileTag(range, "")}.csv`);
}
